// Under-construction curtain, not real security — everything it guards ships in the bundle.

/** SHA-256 of the passphrase. */
const DIGEST = 'a2f0c05f07228535e93d2c3935308328602c121715e44feec155b51d77b32297';

const KEY = 'kg_unlocked_v1';
const COOKIE = 'kg_unlocked';
const YEAR_S = 365 * 24 * 60 * 60;

export function isUnlocked(): boolean {
  try {
    if (localStorage.getItem(KEY) === '1') return true;
  } catch { /* storage blocked; fall through to the cookie */ }
  return document.cookie.split(';').some((c) => c.trim() === `${COOKIE}=1`);
}

function remember(): void {
  // Both, so clearing one does not lock you out again.
  try {
    localStorage.setItem(KEY, '1');
  } catch { /* private mode */ }
  document.cookie = `${COOKIE}=1; path=/; max-age=${YEAR_S}; SameSite=Lax`;
}

async function sha256Hex(s: string): Promise<string> {
  const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(s));
  return [...new Uint8Array(buf)].map((b) => b.toString(16).padStart(2, '0')).join('');
}

/** Renders the curtain and resolves once the right passphrase is entered. */
export function renderLock(root: HTMLElement): Promise<void> {
  return new Promise((resolve) => {
    root.innerHTML = `
<div class="lock">
  <div class="lock-card">
    <h1>Under Construction</h1>
    <form class="lock-form" id="lockForm" autocomplete="off">
      <input type="password" id="lockPw" placeholder="Enter Password" autocomplete="current-password"
        spellcheck="false" aria-label="Enter Password"/>
      <button type="submit" id="lockGo">Enter</button>
    </form>
    <div class="lock-err" id="lockErr"></div>
  </div>
</div>`;

    const form = document.getElementById('lockForm') as HTMLFormElement;
    const pw = document.getElementById('lockPw') as HTMLInputElement;
    const err = document.getElementById('lockErr') as HTMLElement;
    pw.focus();

    form.addEventListener('submit', (ev) => {
      ev.preventDefault();
      void (async () => {
        const hex = await sha256Hex(pw.value);
        if (hex !== DIGEST) {
          err.textContent = 'Not that one.';
          pw.select();
          return;
        }
        err.textContent = '';
        remember();
        resolve();
      })();
    });

    pw.addEventListener('input', () => {
      if (err.textContent) err.textContent = '';
    });
  });
}

/** Console helper: `kg.lock()` re-locks this browser. */
export function relock(): void {
  try {
    localStorage.removeItem(KEY);
  } catch { /* ignore */ }
  document.cookie = `${COOKIE}=; path=/; max-age=0`;
  location.reload();
}
